import React from 'react';
import CONFIG from "../../config";

const { LINKS } = CONFIG;

interface IComplain {
    parentClass: string;
}

const Complain: React.FC<IComplain> = ({ parentClass }) => (
    <div className={parentClass}>
        <div className={`${parentClass}__title`}>Нам важно ваше мнение</div>
        <a href={LINKS.BAIBOL.COMPLAINTS} target="_blank" rel="noopener noreferrer nofollow">Оставить жалобу</a>
        {parentClass === 'footer__complain' && <a href={LINKS.BAIBOL.FEEDBACK} target="_blank" rel="noopener noreferrer nofollow">Оставить отзыв</a>}
    </div>
);

export default Complain;
